// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"vendors-node_modules_glightbox_dist_js_glightbox_min_js":"a813448aea24c6977bca","src_js_components_ui_Glightbox_ts":"c2ba03ebffc0278bb9ec","lazysizes":"882e6874cada87c6257b"}[chunkId] + ".js";
};